import { render, staticRenderFns } from "./ShippingCostModule.vue?vue&type=template&id=78e89546"
import script from "./ShippingCostModule.vue?vue&type=script&lang=js"
export * from "./ShippingCostModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports